import { Node } from "@xyflow/react";
import { useAtomValue } from "jotai";
import { Button, Icon } from "@zapier/design-system";
import {
  nodeAtomFamily,
  getInterfacesOrigin,
  getTablesOrigin,
  DefaultNodeData,
  getAssetLink,
} from "@zapier/canvas-state";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

import { useEmitUserInteractionEvents } from "../../../hooks/useEmitUserInteractionEvents";

type Props = {
  nodeId: string;
};

export function EditAssetButton({ nodeId }: Props) {
  const node = useAtomValue(nodeAtomFamily(nodeId)) as Node<DefaultNodeData>;
  const appId = node.data.services?.[0]?.currentImplementation.id ?? "";
  const isTablesNode = appId.includes(ASSET_APP_IDS.TABLES);
  const isInterfacesNode = appId.includes(ASSET_APP_IDS.INTERFACES);
  const isChatbotsNode = appId.includes(ASSET_APP_IDS.CHATBOTS);
  const isAgentsNode = appId.includes(ASSET_APP_IDS.AGENTS);
  const { emitEventOnAssetOpen } = useEmitUserInteractionEvents();

  return (
    <>
      {isTablesNode && node.data.tableId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(
              `//${getTablesOrigin()}/app/tables/t/${node.data.tableId}`,
              "_blank",
            );
            emitEventOnAssetOpen({
              asset: "table",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Table
        </Button>
      )}
      {isInterfacesNode && node.data.projectId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(
              `//${getInterfacesOrigin()}/interfaces/project/${node.data.projectId}`,
              "_blank",
            );
            emitEventOnAssetOpen({
              asset: "interface",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Interface
        </Button>
      )}
      {isChatbotsNode && node.data.chatbotId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(`/app/chatbots/${node.data.chatbotId}`, "_blank");
            emitEventOnAssetOpen({
              asset: "chatbot",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Chatbot
        </Button>
      )}
      {isAgentsNode && node.data.agentId && (
        <Button
          variant="primary"
          iconPosition="start"
          onPress={() => {
            window.open(
              `${getAssetLink({
                assetType: "agent",
                assetId: node.data.agentId ?? null,
                interfaceProjectId: undefined,
              })}`,
              "_blank",
            );
            emitEventOnAssetOpen({
              asset: "agent",
              location: "sidebar",
            });
          }}
        >
          <Icon name="arrowOffsite" />
          Edit Agent
        </Button>
      )}
    </>
  );
}
